import React from 'react';
import Modal from './Modal';
import { ServiceIllustration } from './ServiceIllustrations';

function ServiceDetailModal({ service, isOpen, onClose }) {
  if (!service) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="service-detail-content">
        <div className="service-detail-header">
          <div className="service-icon-large">
            <ServiceIllustration type={service.id} />
          </div>
          <h2>{service.category}</h2>
        </div>
        
        <p className="service-detail-desc">{service.description}</p>
        
        <div className="service-list">
          <h3>All Services</h3>
          <ul>
            {service.allServices.map((item, index) => (
              <li key={index}>
                <span className="bullet">✓</span>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
}

export default ServiceDetailModal;
